import React, { useEffect } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";

const ClarificationNotice = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-neutral-50">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
        {/* Header */}
        <div className="flex items-center justify-between gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 rounded-full px-4 py-2 border border-gray-300 bg-white hover:bg-gray-50 text-sm"
          >
            <FiArrowLeft /> Geri
          </button>
          <div className="text-right text-xs text-gray-500">
            Son güncelleme: {new Date().toLocaleDateString("tr-TR")}
          </div>
        </div>

        <article className="rounded-2xl bg-white shadow-sm ring-1 ring-gray-100 p-5 sm:p-8 leading-relaxed text-gray-800">
          <header className="mb-6">
            <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">
              KİŞİSEL VERİLERİN KORUNMASI KANUNU (KVKK)
              <br className="hidden sm:block" />
              <span className="block text-[1.15rem] sm:text-xl font-semibold mt-1">
                WEB PORTALI ZİYARETÇİLERİNE YÖNELİK AYDINLATMA METNİ
              </span>
            </h1>
            <p className="mt-3 text-sm text-gray-600">
              Arontech Bilgi Teknolojileri Sanayi ve Ticaret A.Ş. (bundan sonra
              “ARON”) olarak; <strong>https://zenolearn.io</strong> adresindeki
              web sitemizi (ve bağlı dijital market uygulamasını) kullanırken
              bize ilettiğiniz kişisel verilerin korunmasına önem veriyoruz.
              6698 sayılı KVKK kapsamındaki aydınlatma yükümlülüğümüz
              doğrultusunda bu metni bilgilerinize sunarız.
            </p>
          </header>

          {/* Tanımlar */}
          <section className="space-y-3">
            <h2 className="text-xl font-bold">Tanımlar</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Kişisel veri:</strong> Kimliği belirli veya
                belirlenebilir gerçek kişiye ilişkin her türlü bilgi.
              </li>
              <li>
                <strong>Kişisel verilerin işlenmesi:</strong> Verilerin elde
                edilmesi, kaydedilmesi, depolanması, muhafazası, değiştirilmesi,
                açıklanması, aktarılması, devralınması, sınıflandırılması veya
                kullanılmasının engellenmesi dâhil her türlü işlem.
              </li>
              <li>
                <strong>Veri işleyen:</strong> Veri sorumlusunun verdiği yetkiye
                dayanarak onun adına kişisel verileri işleyen gerçek ya da tüzel
                kişi.
              </li>
              <li>
                <strong>Veri kayıt sistemi:</strong> Kişisel verilerin belirli
                kriterlere göre yapılandırılarak işlendiği kayıt sistemi.
              </li>
              <li>
                <strong>Veri sorumlusu:</strong> Kişisel verilerin işleme
                amaçlarını ve vasıtalarını belirleyen, veri kayıt sisteminin
                kurulmasından ve yönetiminden sorumlu gerçek veya tüzel kişi.
              </li>
            </ul>
            <p className="text-sm text-gray-600">
              ARON, KVKK m.10 kapsamındaki aydınlatma yükümlülüğü gereği bu
              metni yayımlar ve mevzuat değişikliklerine paralel olarak
              güncelleme hakkını saklı tutar.
            </p>
          </section>

          <hr className="my-6" />

          {/* 1 */}
          <section className="space-y-3">
            <h2 className="text-xl font-bold">
              1) Metnin Amacı ve ARON’un Veri Sorumlusu Konumu
            </h2>
            <p>
              Veri sorumlusu sıfatıyla ARON; elde edilen kişisel verilerinizi,
              hukuki ilişki kapsamında ve yalnızca işlenmesini gerektiren
              amaçlarla, doğru ve güncel tutmaya özen göstererek kaydeder,
              depolar, muhafaza eder, yeniden düzenler; kanunen talep etmeye
              yetkili kurum ve kuruluşlar ile paylaşabilir ve KVKK’nın öngördüğü
              şartlarda yurt içinde/yurt dışında üçüncü kişilere aktarabilir. Bu
              metin ile üyelerimizin/ziyaretçilerimizin yürüttüğümüz kişisel
              veri işleme faaliyetleri hakkında bilgilendirilmesi ve gerekli
              hallerde açık rızalarının temini amaçlanır.
            </p>
          </section>

          <hr className="my-6" />

          {/* 2 */}
          <section className="space-y-3">
            <h2 className="text-xl font-bold">
              2) Ziyaretçilere Ait Kişisel Verilerin İşlenme Amaçları
            </h2>
            <p>
              Kişisel verileriniz KVKK m.5 ve m.6’da yer alan işleme şartları
              dâhilinde aşağıdaki amaçlarla işlenmektedir:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Web sitemiz üzerinden sunulan ürün ve hizmetlerden
                faydalandırmak için gerekli çalışmaların yapılması ve ilgili iş
                süreçlerinin yürütülmesi,
              </li>
              <li>
                Ticari faaliyetlerin icrası, iş birimleri arasında koordinasyon,
                iş/strateji planlaması ve yönetimi,
              </li>
              <li>
                Hukuki, teknik ve ticari iş güvenliğinin temini; hizmet ve
                içeriklerin ilgi ve ihtiyaçlara göre özelleştirilerek
                önerilmesi/tanıtılması,
              </li>
              <li>
                Olası hak ve alacak taleplerinin tesisi; mevzuattan doğan
                yükümlülüklerin yerine getirilmesi; ziyaretçi kayıtlarının
                oluşturulması ve takibi,
              </li>
              <li>
                Tüketicinin Korunması mevzuatı kapsamındaki yükümlülüklerin
                yerine getirilmesi; kampanya/pazarlama/bilgilendirme, promosyon,
                anket ve memnuniyet çalışmaları,
              </li>
              <li>
                Davranışsal reklamcılık ve yeniden pazarlama faaliyetleri
                (çerezler/benzeri teknolojilerle), kullanıcı deneyiminin
                iyileştirilmesi ve raporlanması.
              </li>
            </ul>
            <p className="text-sm text-gray-600">
              Çerezler aracılığıyla sayfa görüntüleme, ziyaret süresi, hedef
              tamamlama gibi metrikler üzerinden yeniden pazarlama listeleri
              oluşturulabilir; ilgi alanlarına göre hedefli içerikler
              gösterilebilir.
            </p>
          </section>

          <hr className="my-6" />

          {/* 3 */}
          <section className="space-y-3">
            <h2 className="text-xl font-bold">
              3) Kişisel Verilerin Aktarımı (Yurt İçi / Yurt Dışı)
            </h2>
            <p>
              Verileriniz; ürün/hizmetlerden faydalandırma, faaliyetlerin
              icrası, iş/strateji planlaması, hukuki/teknik/ticari güvenliğin
              sağlanması ve kişiye özel pazarlama amaçlarıyla; KVKK m.8 ve
              m.9’daki şartlara uygun olarak ARON yetkilileri, iştiraklerimiz,
              iş ortaklarımız, tedarikçilerimiz, hissedarlarımız, yetkili kamu
              kurum ve kuruluşları ile özel kurumlarla paylaşılabilir. Bu
              kapsamda veriler gerekli şartlar sağlanarak yurt dışına da
              aktarılabilir.
            </p>
          </section>

          <hr className="my-6" />

          {/* 4 */}
          <section className="space-y-4">
            <h2 className="text-xl font-bold">
              4) Kişisel Verilerin Üçüncü Kişilerle Paylaşılması
            </h2>

            <h3 className="font-semibold">ARON Çalışanları</h3>
            <p>
              İlgili işlemlerde satış temsilcileri ve muhasebe personeli gibi
              birimlere gerekli ölçüde veri aktarımı yapılır.
            </p>

            <h3 className="font-semibold">Yurt içinde paylaşım</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Entegrasyon/yazılım/teknik altyapı sağlayıcıları, iletişim
                (telefon, e-posta) ve aracı hizmet sağlayıcıları,
              </li>
              <li>
                Elektronik ticari ileti onayı varsa toplu e-posta ve SMS hizmeti
                sağlayıcıları,
              </li>
              <li>Muhasebe programı sunucuları ve e-fatura entegratörü,</li>
              <li>Santral ve çağrı kayıt hizmeti sağlayıcıları,</li>
              <li>
                Web sitesi danışmanları ve arama motoru aracılık şirketleri.
              </li>
            </ul>

            <h3 className="font-semibold">Yurt dışında paylaşım</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                Sunucuları yurt dışında bulunan ve uluslararası güvenlik
                sertifikalarına sahip yazılım ve domain sağlayıcıları,
              </li>
              <li>
                E-posta hizmetleri ve bulut sunucuları (veriler şifreli biçimde
                saklanabilir).
              </li>
            </ul>
          </section>

          <hr className="my-6" />

          {/* 5 */}
          <section className="space-y-3">
            <h2 className="text-xl font-bold">
              5) Toplama Yöntemi ve Hukuki Sebep
            </h2>
            <p>
              Kişisel verileriniz web sitemiz üzerinden elektronik ortamda
              toplanmakta; KVKK m.5 ve m.6’daki işleme şartları ile bu
              Aydınlatma Metninde belirtilen amaçlar doğrultusunda
              işlenebilmekte/aktarılabilmektedir.
            </p>
          </section>

          <hr className="my-6" />

          {/* 6 */}
          <section className="space-y-3">
            <h2 className="text-xl font-bold">6) Saklama Süreleri</h2>
            <p>
              Mevzuatta özel bir süre öngörülmüşse bu süre boyunca saklanır.
              Aksi takdirde, işleme amacının gerektirdiği süre kadar muhafaza
              edilir; amaç ortadan kalktığında silinir, yok edilir veya anonim
              hale getirilir. Olası hukuki uyuşmazlıklar için zamanaşımı
              süreleriyle sınırlı olmak üzere delil niteliğinde saklama
              yapılabilir.
            </p>
          </section>

          <hr className="my-6" />

          {/* 7 */}
          <section className="space-y-3">
            <h2 className="text-xl font-bold">
              7) İşlenen Kişisel Veri Kategorileri
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Kimlik Bilgisi:</strong> İsim-soyisim, doğum tarihi,
                T.C. kimlik no.
              </li>
              <li>
                <strong>İletişim Bilgisi:</strong> Telefon, e-posta.
              </li>
              <li>
                <strong>Erişim/İşlem Bilgisi:</strong> IP, cihaz türü, işletim
                sistemi/sürümü, tarayıcı bilgisi, çerezlerle önceki giriş/arama
                bilgileri, ziyaret edilen sayfalar ve süre.
              </li>
              <li>
                <strong>İşitsel Veri:</strong> Çağrı merkezi/santral ses
                kayıtları.
              </li>
            </ul>
          </section>

          <hr className="my-6" />

          {/* 8 */}
          <section className="space-y-3">
            <h2 className="text-xl font-bold">
              8) Veri Sahibi Olarak Haklarınız (KVKK m.11)
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
              <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
              <li>
                İşleme amacını ve amacına uygun kullanılıp kullanılmadığını
                öğrenme,
              </li>
              <li>Yurt içi/yurt dışına aktarıldığı üçüncü kişileri bilme,</li>
              <li>
                Eksik/yanlış işlenmişse düzeltilmesini ve bunu üçüncü kişilere
                bildirilmesini isteme,
              </li>
              <li>
                Şartları oluşmuşsa silinmesini/yok edilmesini ve bunun üçüncü
                kişilere bildirilmesini isteme,
              </li>
              <li>
                Münhasıran otomatik sistemlerle analiz sonucu aleyhe bir sonuca
                itiraz etme,
              </li>
              <li>
                Kanuna aykırı işleme nedeniyle zarara uğramanız hâlinde tazmin
                talep etme.
              </li>
            </ul>
            <p className="text-sm text-gray-600">
              Başvurular; sitemizdeki iletişim formu, yazılı/imzalı başvuru,
              “Veri Sorumlusuna Başvuru Formu”, KEP veya daha önce bildirilen
              e-posta üzerinden{" "}
              <a
                href="mailto:info@arontechnology.com"
                className="underline text-emerald-600"
              >
                info@arontechnology.com
              </a>{" "}
              adresine; güvenli elektronik imza/mobil imza ile yapılabilir.
              Talepler, niteliğine göre en geç 30 gün içinde sonuçlandırılır.
              (Kurum tarifesine göre masraf doğarsa ücret talep edilebilir.)
            </p>
          </section>

          <footer className="mt-10 pt-6 border-t border-gray-100 text-sm text-gray-600">
            <p>
              ARON, bu Aydınlatma Metni’nde her zaman değişiklik yapma hakkını
              saklı tutar. Güncel iletişim bilgileri{" "}
              <a
                href="https://www.zenolearn.io"
                target="_blank"
                rel="noreferrer"
                className="text-emerald-600 underline"
              >
                www.zenolearn.io
              </a>{" "}
              adresindeki “İletişim” bölümünde yer alır.
            </p>

            <div className="mt-3 flex flex-wrap gap-3 text-sm">
              <Link to="/legal/terms" className="underline text-gray-700">
                Kullanım Koşulları
              </Link>
              <span className="opacity-40">•</span>
              <Link to="/legal/privacy" className="underline text-gray-700">
                KVKK Gizlilik Politikası
              </Link>
            </div>
          </footer>
        </article>
      </div>
    </main>
  );
};

export default ClarificationNotice;
